import { Link } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import mark from '../assets/logo-mark.svg';

/* Each label is what the section says, not the category it belongs to.
   "Accountability" is a topic; "One contract" is the promise. */
const SECTIONS = [
  { hash: 'problem', label: 'Handoffs' },
  { hash: 'stack', label: 'The layer' },
  { hash: 'aisle', label: 'Shared floor' },
  { hash: 'levels', label: 'Levels' },
  { hash: 'accountable', label: 'One contract' },
];

export function Nav() {
  const [open, setOpen] = useState(false);

  // Escape closes it, and so does any resize back to the width where the
  // links live in the bar — otherwise the panel stays mounted and invisible
  // with its links still in the tab order.
  useEffect(() => {
    if (!open) return;
    const close = (event: KeyboardEvent) => event.key === 'Escape' && setOpen(false);
    const wide = matchMedia('(min-width: 901px)');
    const onWide = () => wide.matches && setOpen(false);
    document.addEventListener('keydown', close);
    wide.addEventListener('change', onWide);
    return () => {
      document.removeEventListener('keydown', close);
      wide.removeEventListener('change', onWide);
    };
  }, [open]);

  return (
    <header className={open ? 'nav nav--open' : 'nav'}>
      <Link className="nav__brand" to="/" hash="top" onClick={() => setOpen(false)}>
        <img src={mark} alt="" width={33} height={38} />
        <span>Synapse&nbsp;Fleet</span>
      </Link>

      <nav className="nav__links" id="nav-menu" aria-label="Sections">
        {SECTIONS.map((s) => (
          <Link key={s.hash} to="/" hash={s.hash} onClick={() => setOpen(false)}>
            {s.label}
          </Link>
        ))}
      </nav>

      <Link className="nav__cta" to="/contact" onClick={() => setOpen(false)}>
        Book an assessment<span aria-hidden="true">↗</span>
      </Link>

      {/* Two drawn bars that cross rather than a glyph, so the open state is
          the same object having moved. */}
      <button
        className="nav__menu"
        type="button"
        aria-expanded={open}
        aria-controls="nav-menu"
        aria-label={open ? 'Close menu' : 'Open menu'}
        onClick={() => setOpen((was) => !was)}
      >
        <span />
        <span />
      </button>
    </header>
  );
}
